import React, { useState, useEffect } from "react";
import api from "../../services/api";
import T from "../../assets/styles/theme";import "../../assets/styles/PM/PMProfilePg.css";

function PMProfilePg() {
  const [profile, setProfile] = useState(null);
  const [experience, setExperience] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
    api.getProfile().catch(() => ({})),
    api.getExperience().catch(() => null)]
    ).then(([prof, exp]) => {
      setProfile(prof.profile || prof || {});
      setExperience(exp);
      setLoading(false);
    });
  }, []);

  if (loading) return <div style={{ "--pmprofilepg-1-color": T.textMuted }} className="pmprofilepg-dyn-1">Loading profile...</div>;

  const p = profile || {};
  const exp = experience || {};
  const expYears = exp.experience_months ? Math.floor(exp.experience_months / 12) : 0;
  const expMonths = exp.experience_months ? exp.experience_months % 12 : 0;

  const fields = [
  ["Name", p.name || p.full_name || ""],
  ["Email", p.email || ""],
  ["Role", p.role || ""],
  ["Department", p.department || ""],
  ["Designation", p.designation || ""],
  ["Team", p.team || ""],
  ["Phone", p.phone || ""],
  ["Location", p.location || ""],
  ["Manager", p.manager || ""],
  ["Employee ID", p.emp_id || ""],
  ["Joining Date", exp.joining_date ? new Date(exp.joining_date).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : ""],
  ["Experience", exp.experience_months ? `${expYears} years ${expMonths} months` : ""]];


  return (
    <div>
      <div className="sec">My Profile</div>
      <div className="cd">
        <div className="cd-h"><div className="cd-t">Profile Details</div></div>
        <div className="cd-b">
          {fields.map(([label, val], i) =>
          <div className="pf" key={i}>
              <div style={{ "--pmprofilepg-2-color": T.textMuted }} className="pmprofilepg-dyn-2">{label}</div>
              <div className="pmprofilepg-inline-1">{val || "—"}</div>
            </div>
          )}
        </div>
      </div>
      {exp.current_projects && exp.current_projects.length > 0 &&
      <div className="cd pmprofilepg-inline-2">
          <div className="cd-h"><div className="cd-t">Current Projects</div></div>
          <div className="cd-b">
            {exp.current_projects.map((proj, i) =>
          <div className="pf" key={i}>
                <div className="pmprofilepg-inline-3">{proj.name}</div>
                <span className="chip chip-ip">{proj.status}</span>
              </div>
          )}
          </div>
        </div>
      }
      {exp.completed_projects && exp.completed_projects.length > 0 &&
      <div className="cd pmprofilepg-inline-4">
          <div className="cd-h"><div className="cd-t">Completed Projects</div></div>
          <div className="cd-b">
            {exp.completed_projects.map((proj, i) =>
          <div className="pf" key={i}>
                <div className="pmprofilepg-inline-5">{proj.name}</div>
                <span className="chip chip-ok">Done</span>
              </div>
          )}
          </div>
        </div>
      }
    </div>);

}

export default PMProfilePg;